import { z } from "zod";
import { LocalizedTextSchema } from "./common.js";

export const ResearchTreeSchema = z.enum(["economy", "military", "development", "defense"]);
export type ResearchTree = z.infer<typeof ResearchTreeSchema>;

/** Effect keys consumed by rules and services; adding one here requires a consumer. */
export const RESEARCH_EFFECT_KEYS = [
  "production.RAT",
  "production.POL",
  "production.ALY",
  "production.ENC",
  "production.SCR",
  "production.all",
  "storage.capacity",
  "storage.protected",
  "gather.speed",
  "march.cargo",
  "march.speed",
  "trade.discount",
  "salvage.yield",
  "unit.defender.hp",
  "unit.defender.def",
  "unit.attacker.atk",
  "unit.saboteur.atk",
  "unit.saboteur.crit",
  "unit.commander.hp",
  "unit.support.aura",
  "unit.chassis.tank",
  "unit.chassis.mecha",
  "unit.chassis.tripod",
  "unit.all.atk",
  "unit.all.def",
  "unit.all.hp",
  "unit.crit",
  "unit.energy",
  "commander.pulse",
  "build.speed",
  "research.speed",
  "repair.speed",
  "fabrication.discount",
  "march.slots",
  "stamina.cap",
  "xp.gain",
  "cdc.drop",
  "wall.hp",
  "turret.power",
  "trap.capacity",
  "trap.damage",
  "shield.discount",
  "burn.duration",
  "garrison.def",
  "garrison.atk",
  "scout.resist",
  "warning.time",
] as const;
export const ResearchEffectKeySchema = z.enum(RESEARCH_EFFECT_KEYS);
export type ResearchEffectKey = z.infer<typeof ResearchEffectKeySchema>;

export const ResearchNodeDefSchema = z.object({
  id: z.string().regex(/^rsh\.(economy|military|development|defense)\.[a-z0-9_]+$/),
  tree: ResearchTreeSchema,
  name: LocalizedTextSchema,
  description: LocalizedTextSchema,
  /** 1..7, gates the Data Lab level (`maxResearchTier`). */
  tier: z.number().int().min(1).max(7),
  maxLevel: z.number().int().min(1).max(10),
  requires: z.array(z.string()),
  effect: z.object({ key: ResearchEffectKeySchema, perLevel: z.number() }),
  costWeight: z.number().positive(),
  timeWeight: z.number().positive(),
});
export type ResearchNodeDef = z.infer<typeof ResearchNodeDefSchema>;
